import {
    CREATE_QUESTION,
    CREATE_QUESTION_SUCCESS,
    UPDATE_QUESTION,
    UPDATE_QUESTION_SUCCESS,
    UPLOAD_QUESTION_COVER,
    UPLOAD_QUESTION_COVER_SUCCESS,
    UPDATE_QUESTION_FEEDBACK,
    UPDATE_QUESTION_FEEDBACK_SUCCESS,
    DELETE_QUESTION,
    DELETE_QUESTION_SUCCESS,
    COPY_QUESTION,
    COPY_QUESTION_SUCCESS,
    HIDE_QUESTION,
    HIDE_QUESTION_SUCCESS,
    DELETE_QUESTION_COVER,
    DELETE_QUESTION_COVER_SUCCESS,
    PIN_QUESTION,
    PIN_QUESTION_SUCCESS,
    UPDATE_QUESTION_FEEDBACK_SETTINGS,
    UPDATE_QUESTION_FEEDBACK_SETTINGS_SUCCESS,
    UPDATE_QUESTION_DRAG_DROP,
    UPDATE_QUESTION_DRAG_DROP_SUCCESS,

} from './constants';

/**
 *
 * @param quizID
 * @param quizLocalizationId
 * @param question
 * @param questionType
 * @param langId
 * @param resolve
 * @returns {{question: *, resolve: *, quizID: *, type: string, quizLocalizationId: *, langId: *, questionType: *}}
 */
const createQuestion = (quizID, quizLocalizationId, question, questionType, langId, resolve) => ({
    type: CREATE_QUESTION,
    quizID,
    quizLocalizationId,
    question,
    questionType,
    langId,
    resolve
});
/**
 *
 * @param newQuestion
 * @returns {{type: string, newQuestion: *}}
 */
const createQuestionSuccess = newQuestion => ({
    type: CREATE_QUESTION_SUCCESS,
    newQuestion
});
/**
 *
 * @param questionID
 * @param keyName
 * @param updatedQuestionPiece
 * @returns {{questionID: *, keyName: *, updatedQuestionPiece: *, type: string}}
 */
const updateQuestion = (questionID, keyName, updatedQuestionPiece) => ({
    type: UPDATE_QUESTION,
    questionID,
    keyName,
    updatedQuestionPiece
});
/**
 *
 * @param questionID
 * @param updatedQuestionPiece
 * @returns {{questionID: *, updatedQuestionPiece: *, type: string}}
 */
const updateQuestionSuccess = (questionID, updatedQuestionPiece) => ({
    type: UPDATE_QUESTION_SUCCESS,
    questionID,
    updatedQuestionPiece
});
/**
 *
 * @param questionID
 * @param localizationID
 * @param image
 * @param screenType
 * @returns {{image: *, questionID: *, localizationID: *, screenType: *, type: string}}
 */
const uploadQuestionCover = (questionID, localizationID, image,screenType) => ({
    type: UPLOAD_QUESTION_COVER,
    localizationID,
    questionID,
    image,
    screenType
});

/**
 *
 * @param questionID
 * @param localizationID
 * @returns {{questionID: *, localizationID: *, type: string}}
 */
const deleteQuestionCover = (questionID, localizationID) => ({
    type:DELETE_QUESTION_COVER,
    localizationID,
    questionID
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const deleteQuestionCoverSuccess = (questionID, question) => ({
    type: DELETE_QUESTION_COVER_SUCCESS,
    questionID,
    question
});

/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const uploadQuestionCoverSuccess = (questionID, question) => ({
    type: UPLOAD_QUESTION_COVER_SUCCESS,
    questionID,
    question
});
/**
 *
 * @param questionID
 * @param feedback
 * @returns {{feedback: *, questionID: *, type: string}}
 */
const updateQuestionFeedback = ( questionID, feedback ) => ({
    type: UPDATE_QUESTION_FEEDBACK,
    questionID,
    feedback
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const updateQuestionFeedbackSuccess = ( questionID, question ) => ({
    type: UPDATE_QUESTION_FEEDBACK_SUCCESS,
    questionID,
    question
});

/**
 *
 * @param questionID
 * @param curQuestionId
 * @param feedbackSettings
 * @returns {{questionID: *, curQuestionId: *, type: string, feedbackSettings: *}}
 */
const updateQuestionFeedbackSettings = ( questionID, curQuestionId, feedbackSettings ) => ({
    type: UPDATE_QUESTION_FEEDBACK_SETTINGS,
    questionID,
    curQuestionId,
    feedbackSettings
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const updateQuestionFeedbackSettingsSuccess = ( questionID, question ) => ({
    type: UPDATE_QUESTION_FEEDBACK_SETTINGS_SUCCESS,
    questionID,
    question
});


/**
 *
 * @param questionID
 * @param questionType
 * @param curQuestion1d
 * @returns {{curQuestion1d: *, questionID: *, type: string, questionType: *}}
 */
const deleteQuestion = ( questionID, questionType ,curQuestion1d) => ({
    type: DELETE_QUESTION,
    questionID,
    questionType,
    curQuestion1d
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const deleteQuestionSuccess = ( questionID, question ) => ({
    type: DELETE_QUESTION_SUCCESS,
    questionID,
    question
});
/**
 *
 * @param questionID
 * @param questionType
 * @param curQuestion1d
 * @returns {{curQuestion1d: *, questionID: *, type: string, questionType: *}}
 */
const copyQuestion = ( questionID, questionType, curQuestion1d) => ({
    type: COPY_QUESTION,
    questionID,
    questionType,
    curQuestion1d
});
/**
 *
 * @param questionID
 * @param newQuestion
 * @returns {{questionID: *, type: string, newQuestion: *}}
 */
const copyQuestionSuccess = (questionID, newQuestion) => ({
    type: COPY_QUESTION_SUCCESS,
    questionID,
    newQuestion
});
/**
 *
 * @param questionID
 * @param questionType
 * @param curQuestion1d
 * @returns {{curQuestion1d: *, questionID: *, type: string, questionType: *}}
 */
const hideQuestion = ( questionID, questionType  ,curQuestion1d) => ({
    type: HIDE_QUESTION,
    questionID,
    questionType ,curQuestion1d
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const hideQuestionSuccess = (questionID, question) => ({
    type: HIDE_QUESTION_SUCCESS,
    questionID,
    question
});
/**
 *
 * @param questionID
 * @param questionType
 * @param curQuestion1d
 * @returns {{curQuestion1d: *, questionID: *, type: string, questionType: *}}
 */
const pinQuestion = ( questionID, questionType  ,curQuestion1d) => ({
    type: PIN_QUESTION,
    questionID,
    questionType ,curQuestion1d
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const pinQuestionSuccess = (questionID, question) => ({
    type: PIN_QUESTION_SUCCESS,
    questionID,
    question
});
/**
 *
 * @param quizID
 * @param result
 * @returns {{result: *, quizID: *, type: string}}
 */
const updateQuestionDragDrop = (quizID, result) => ({
    type: UPDATE_QUESTION_DRAG_DROP,
    quizID,
    result
});
/**
 *
 * @param newQuestions
 * @returns {{newQuestions: *, type: string}}
 */
const updateQuestionDragDropSuccess = (newQuestions) => ({
    type: UPDATE_QUESTION_DRAG_DROP_SUCCESS,
    newQuestions
});


export {
    createQuestion,
    createQuestionSuccess,
    updateQuestion,
    updateQuestionSuccess,
    uploadQuestionCover,
    uploadQuestionCoverSuccess,
    updateQuestionFeedback,
    updateQuestionFeedbackSuccess,
    deleteQuestion,
    deleteQuestionSuccess,
    copyQuestion,
    copyQuestionSuccess,
    hideQuestion,
    hideQuestionSuccess,
    pinQuestion,
    pinQuestionSuccess,
    updateQuestionFeedbackSettings,
    updateQuestionFeedbackSettingsSuccess,
    updateQuestionDragDrop,
    updateQuestionDragDropSuccess,
    deleteQuestionCover,
    deleteQuestionCoverSuccess
};
